import React from "react";
import aboutStartImg from "../assets/about-start-img.webp";
import { useTranslation, Trans } from 'react-i18next';


export default function AboutStart() {
  const { t } = useTranslation();
  return (
    <section className="bg-white">
      <div className="mx-auto px-[20px] sm:px-[100px] lg:px-[200px] py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          {/* Левая колонка — текст */}
          <div className="lg:col-span-5">
            <h1 className="text-sm text-gray-500 mb-3">{t('$AboutUs')}</h1>

            <p className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-6">
            <Trans
              i18nKey="$Header8"
              components={{ highlight: <h2 className="text-4xl sm:text-5xl font-extrabold leading-tight mb-2">
                <span className="bg-gradient-to-r from-purple-700 to-purple-400 bg-clip-text text-transparent">
                </span>
              </h2>
              }}
            />
            </p>

            <p className="text-gray-600 mb-4">
              {t('$Text4')}
            </p>
          </div>

          {/* Правая колонка — изображение */}
          <div className="lg:col-span-7">
            <img
              src={aboutStartImg}
              alt="Коллаж с лучшими практиками"
              className="w-full h-auto lg:max-w-none max-w-[640px] ml-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
